import React, {useState} from 'react';
import MegaMenu from './../MegaMenu';
import {useSalesContactData} from '../../../queries/salesContact'
import PopupSalesDialog from '../../PopupSales';

function Navbar(props) {
    const [open, setOpen] = useState(false);
    const popUpData = useSalesContactData()
    if(popUpData.loading) return <div></div>
      if(popUpData.error) return <div>error!</div>
     
      const handleClose = () => {
        setOpen(false);
        
      };
      function showInfo() {
        setOpen(true);
      }
    return (
        <div class="ruby-menu-demo-header">
             {popUpData.data.salesFastContact[0] && <PopupSalesDialog
  popupText={popUpData.data.salesFastContact[0].bag.contentItems[0].salesInfo.html}
  title={popUpData.data.salesFastContact[0].displayText}
  open={open}
  onClose={handleClose}
  
 
/>}
         <div class="ruby-wrapper" style={{backgroundColor:"#fff"}}>
            <ul className="ruby-menu">
                <MegaMenu  openDialog={{setOpen}}/>
            </ul>
        </div>
        </div>
    //     <ul className="main-menu nav" style={{direction: 'ltr'}}>
    //     <NavbarItem />
    // </ul>
    );
}

export default Navbar;